import crud from '@/crud/form/form'
import resources from '../../resources'
import methods from './methods'
import components from './components'
import computed from './computed'
import validations from './validations'
import mounted from './mounted'

export default {
  components,
  computed,
  validations,
  mounted,
  mixins: [crud, resources],
  methods
}



// WEBPACK FOOTER //
// ./src/app/professional/company/addresses/form/resources/index.js